import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router, ActivatedRoute } from "@angular/router";
import { DataService, PlayerService } from "/Users/curtis/Downloads/Listen.FM_Build_myself/source_4.2.2020/fm181/src/_services/index";

@Component({
  selector: "app-category",
  templateUrl: "./category.component.html"
})
export class CategoryComponent implements OnInit {
  categories: any[];
  category: any;
  slug: string;

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private playerService: PlayerService,
    private router: Router,
    private titleService: Title
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.slug = this.route.snapshot.params.slug;
  }

  ngOnInit() {
    if (this.slug) {
      this.dataService.callPlaylist().subscribe(result => {
        this.categories = this.dataService.getPlaylist();
        this.category = this.dataService.getCategory(this.slug);
        this.titleService.setTitle(this.category.name + " - Listen.FM");
      });
      this.categories = this.dataService.getPlaylist();
      this.category = this.dataService.getCategory(this.slug);
    } else {
      this.titleService.setTitle("ALL GENRES  - Listen.FM");
      this.dataService.callPlaylist().subscribe(result => {
        this.categories = this.dataService.getPlaylist();
      });
      this.categories = this.dataService.getPlaylist();
    }
  }
}
